module.exports = __webpack_public_path__ + "c69ea74e3589490a88b2aa6fd27f1f89.svg";